"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaBanner = void 0;
var _context = require("../../context");
var _components = require("./components");
var _jsxRuntime = require("react/jsx-runtime");
const TopAreaBanner = () => {
  const {
    loading,
    visible
  } = (0, _context.useTopAreaBanner)();
  if (!visible) {
    return null;
  }
  return loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TopAreaBannerSkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.TopAreaBannerContent, {});
};
exports.TopAreaBanner = TopAreaBanner;
